import { useLocation } from "react-router-dom";
import Left from "./Left";
import Center from "./Center";
import Right from "./Right";
import "./Terms.scss";
import Header from "../../../components/header/Header";
import Footer from "../../../components/data-solutions-components/Footer/Footer";

const routeMap = {
  // ===== GENERAL BUSINESS POLICIES =====
  "/terms-conditions": "termsGeneral",
  "/privacy-policy": "generalPrivacy",
  "/cookie-policy": "cookiePolicy",
  "/payment-portal-terms": "paymentPortalTerms",
  "/fraudulent-communications": "fraudulentCommunications",
  "/email-pseudonym-policy": "emailCommunicationPseudonymPolicy",

  // ===== CONFERENCE POLICIES =====
  "/conference-privacy-policy": "conferencePrivacyPolicy",
  "/conference-terms-conditions": "conferenceTermsConditions",
  "/code-of-conduct": "codeOfConduct",
  "/media-partnership-terms": "mediaPartnership",
};

export default function Terms() {
  const location = useLocation();

  const currentPolicy =
    routeMap[location.pathname] || "generalPrivacy";

  return (
    <>
    <Header/>
    <div className="policy-layout flex" >
      <Left currentPolicy={currentPolicy} />
      <Center currentPolicy={currentPolicy} />
      <Right currentPolicy={currentPolicy} />
    </div>
    <Footer/>
    </>
  );
}
